import React, {
    Component
} from 'react'
import {
    Nav,
    NavLink,
    Link,
} from 'react-router-dom'
import { actionTypes } from '../constants';
import _ from 'lodash';

import ArrowTopRightThickIcon from 'mdi-react/ArrowTopRightThickIcon'
import LinkButton from '../widgets/button-link'
import ChipDetails from '../widgets/chip-details'

export default class Container extends Component {
    constructor() {
        super()
        this.state = {
        }
    }

    render() {
        // console.log(this.props);
        // console.log(this.state);

        if(!this.props.departments.is_loaded){
            return ''  // hide while loading
        }

        let department = this.props.department;

        return (
            <div className="card-content">
                <h2>{department.name}</h2>
                <br/>
                <div className="chip-details">
                    <ChipDetails
                        link={`https://citadel.virtualclaimsadjuster.com/Insurers/viewer/general.asp?pid=${department.vcaInsurerId}`}
                        label={department.vcaApiError ? 'Error' : `VCA #${department.vcaInsurerId}`}
                        status={department.vcaApiError ? 'error' : 'success'}
                        tooltip={department.vcaApiError ? department.vcaApiError: (department.active ? 'Active' : 'Inactive')}
                    />
                </div>
                <div className="details-row">
                    <div className="details-item">
                        <div className="details-item-label">
                            Dept. Phone
                        </div>
                        <div className="details-item-value">
                            {department.phone}
                        </div>
                    </div>
                </div>
                <div className="details-row">
                    <div className="details-item">
                        <div className="details-item-label">
                            Dept. Notes
                        </div>
                        <div className="details-item-value" style={{fontSize: '0.85rem', fontWeight: 'normal'}}>
                            {department.notes}
                        </div>
                    </div>
                </div>
                <div className="details-row">
                    <div className="details-item">
                        <div className="details-item-label">
                            Contact Name
                        </div>
                        <div className="details-item-value">
                            {_.get(department, ['contact', 'firstname'], null)}
                            &nbsp;
                            {_.get(department, ['contact', 'lastname'], null)}
                        </div>
                    </div>
                    <div className="details-item">
                        <div className="details-item-label">
                            Email
                        </div>
                        <div className="details-item-value">
                            {_.get(department, ['contact', 'email'], null)}
                        </div>
                    </div>
                    <div className="details-item">
                        <div className="details-item-label">
                            Phone
                        </div>
                        <div className="details-item-value">
                            {_.get(department, ['contact', 'phone'], null)}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
